//Components
import { ResumeAnswersTest } from '../components/ResumeAnswersTest';
import { SoundButton } from '../components/Sounds';
//Axios
import { baseAxios } from "../api/Axios";


//Request
const request = async (body)=>{
    //Form data
    const formdata = new FormData();
    formdata.append("category", localStorage.getItem('category-trivia-test'));
    formdata.append("questions", body);
    //Response
    const response = await baseAxios.post('/save-practice', formdata);
    return response;
}
//Config
const QuestionsTriviaTest = ()=>{
    const questions = document.querySelectorAll('#render-questions-test input');
    const buttons = document.querySelectorAll('#render-questions-test .block .btn');
    const cancelTrivia = document.querySelectorAll('#render-questions-test .block #cancel-trivia');
    const loader = document.querySelector('.loader');

    //Enable first question
    questions[0] && questions[0].closest('.block').classList.add('active');

    //get info answer
    questions.forEach((question)=>{
        question.addEventListener('click', ()=>{
            const currentButtonEnable = document.querySelector('#render-questions-test .block.active .btn');
            const id = question.id;
            currentButtonEnable.dataset.answer = id;
            currentButtonEnable.classList.remove('disabled-trivia');
        });
    });

    //Next question
    buttons.forEach((button)=>{
        button.addEventListener('click', ()=>{
            const questions = JSON.parse(localStorage.getItem('questions-test'));
            const parent = button.closest('.block');
            const parseTime = parseInt(button.dataset.time);
            //Set state to question
            const questionsCopy = [...questions];
            const question = questionsCopy.findIndex(question => question.id === button.dataset.question);
            questionsCopy[question].state = false;
            questionsCopy[question].ans = button.dataset.answer;
            questionsCopy[question].time = parseTime;
            localStorage.setItem('questions-test', JSON.stringify(questionsCopy));
            //Disable current question and enable next question
            if(parent.nextElementSibling){
                parent && parent.classList.remove('active');
                parent.nextElementSibling.classList.add('active');
            }else{
                const body = localStorage.getItem('questions-test');
                loader.classList.remove('disabled');
                button.remove();
                //Request
                request(body)
                    .then(res=>{
                        setTimeout(()=>{
                            ResumeAnswersTest(res.data);
                            localStorage.removeItem('questions-test');
                            localStorage.removeItem('category-trivia-test');
                            loader.classList.add('disabled');
                        },1500);
                    }).catch(err=>{
                        console.log(err);
                    });
            }
        });
    });
    //Cancel trivia
    cancelTrivia.forEach((btn)=>{
        btn.addEventListener('click', ()=>{
            localStorage.removeItem('questions-test');
            localStorage.removeItem('category-trivia-test');
            // document.querySelector('#trivia-test').classList.add('hidden');
            // document.querySelector('#trivia-categories-test').classList.remove('hidden');
            // document.querySelectorAll('#trivia-test .block').forEach((data)=>{
            //     data.remove();
            // });
            window.location.reload();
        });
    });

    SoundButton();
}

export { QuestionsTriviaTest }